window.theme = window.theme || {};
window.sr = ScrollReveal();
function Reveal() {
  sr.reveal('.anim-in-slide', { scale: 1, distance: '16px', reset: true }, 50);
  sr.reveal('.anim-in-zoom', { scale: .9, reset: true });
}
Reveal();

var $thecart = $('#top-cart');

var OwlArrowNext = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 68 68.5" xml:space="preserve"><polygon points="44.9 34 23.9 0 23.1 0.5 43.9 34.3 23.1 68 23.9 68.5 44.9 34.5 44.5 34.3 " fill="#4D4D4D"/></svg>';
var OwlArrowPrev = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 68 68.5" xml:space="preserve"><polygon points="23.1 34.5 44.1 68.5 44.9 68 24.1 34.3 44.9 0.5 44.1 0 23.1 34 23.5 34.3 " fill="#4D4D4D"/></svg>';



var sizePreference = false;
if(Cookies.get('size-preference') != undefined) {
  sizePreference = Cookies.get('size-preference');
}

$.extend(jQuery.easing,{myEase:function(x,t,b,c,d){return -c *(t/=d)*(t-2) + b;}});

if(window.location.search ) {
  var url = window.location.search;
  /*
  if (url.match("cookie=remove").length > 0) {
    Cookies.remove('hide_header_signup');
  }
  */
}


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})(@{1}?\d{1}?x{1}?)*[_\.]/);

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      }
      else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();


$(document).ready(function($) {


  function CheckCurrency() {
    //var shopCurrency = 'EUR';
    //var cookieCurrency = Currency.cookie.read();
    //var currentCurrency = $('#current-currency').data('currency');
    //if(cookieCurrency) {
    //Currency.convertAll(shopCurrency, cookieCurrency);
    //}
  }
  /*
  $(document).on('click','#collection-sidebar h3, #collection-sidebar h4',function(e) {
    if($(window).width() > 768) {
    	e.preventDefault();
    	$(this).toggleClass('active').next().slideToggle('fast','myEase');
    } 
  });
  */

  function MFP() {
    if($('.mfp-inline').length) {
      $('.mfp-inline').magnificPopup({
        type: 'inline',
        midClick: true,
        removalDelay: 500,
        mainClass: 'mfp-with-zoom'
      });
    }
  }
  MFP();

  $(document).on('click','.sidebar-accordion h4.has_submenu',function(e) {
    e.preventDefault();
    $(this).toggleClass('active').next().slideToggle('fast','myEase');
  });

  if($(window).width() <= 768) {
    $('#refined-by').on('click',function(e) {
      e.preventDefault();
      $('.filters').fadeToggle('fast');
    });
    $('.refined-close').on('click',function(e) {
      e.preventDefault();
      $('.filters').fadeToggle('fast');
    });
    $('#mobile-sort-link').on('click',function(e) {
      e.preventDefault();
      $('#sort-mobile').fadeToggle('fast');
    });
    $('.mobile-sort-close').on('click',function(e) {
      e.preventDefault();
      $('#sort-mobile').fadeToggle();
    });

    $('#modify-fit-search').on('click',function(e) {
      e.preventDefault();
      $('#collection-sidebar').slideToggle();
    });

  }


  $('.mega-link').hover(
    function() {
      var newimg = $(this).data('img');
      $('.mega-image').css("background-image", "url("+newimg+")");
    }, function() {
    }
  );

  $(document).on('click','.thumb-img', function(e) {
    e.preventDefault();
    $(".cloud-zoom img").attr("src",$(this).attr("href"));
    $(".main-image__img").attr("src",$(this).attr("href"));
    return false;
  });
  $('.cloud-zoom').zoom();



  $('html').removeClass('no-js');



  $('.nav-item a[href="#"]').on('click',function(e) {
    e.preventDefault();
  });


  $('#mobile-search').on('click',function(e) {
    e.preventDefault();
    $('#mobile-search-form').fadeToggle('fast');
    $('#mobile-search-form input[type=text]').focus();
  });

  $('#mobile-search-form-bg,.msf-close').on('click',function(e) {
    $('#mobile-search-form').fadeOut();
  });

  $("#main a[href^='http://'],#footer a[href^='https://']").attr("target","_blank");


  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

  $('.fieldset.anim').find('input').on('input', function (e) {
    $(e.currentTarget).attr('data-empty', !e.currentTarget.value);
  });

  //$input.data('ui-autocomplete') != undefined;

  $('#my-commission-inner .btn').on('click',function(e) {
    e.preventDefault();
    //var $currentIFrame = $('.sweettooth-launcher-frame');
    //$currentIFrame.contents().find(".sweettooth-launcher-button").trigger("click");
  });




  if($('#index-carousel-1').length) {

    var owl = $('#index-carousel-1');
    owl.on('initialized.owl.carousel',function(event) {
      var element = $(event.target); 
      $('#index-carousel-1 .owl-nav').removeClass('disabled');
      $('#index-carousel-1').imagesLoaded(function(){
        //var h = ($('#index-carousel-1').find('.prod-image-wrap').height() / 2) + ($('#index-carousel-1 .owl-prev').height() / 2);
        var h = ($('#index-carousel-1').find('.owl-item').height() - $('#index-carousel-1').find('.prod-image-wrap').height()) / 2 + 5 ;
        $('#index-carousel-1 .owl-prev').css("margin-top","-"+h+"px");
        $('#index-carousel-1 .owl-next').css("margin-top","-"+h+"px");
      });
    });
    var mobile_visible = $('#index-carousel-1').data('items-mobile');
    var desktop_visible = $('#index-carousel-1').data('items');
    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      dots: false,
      responsive:{
        0:{
          items: mobile_visible
        },
        600:{
          items: desktop_visible
        }

      },
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }

  if($('#the-index-hero').length) {
    var owl = $('#the-index-hero');
    //owl.find('.owl-item').hide();
    owl.on('initialized.owl.carousel',function(event) {
      var element = $(event.target); 
      owl.show().css('opacity','1').css('visibility','visible');
    });
    //var ttl = parseInt(owl.data('blocks'));
    //var min = 1;
    //var randomized = Math.floor(Math.random() * (ttl - min + 1)) + min;
    owl.owlCarousel({
      loop:true,
      margin: 0,
      autoplay: true,
      nav: false,
      lazyLoad: false,
      autoHeight: true,
      dots: true,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
      //startPosition: randomized

    });
  }

  if($('#about-quotes').length) {
    var owl = $('#about-quotes');
    var ttl = parseInt(owl.data('blocks'));
    var min = 1;
    var randomized = Math.floor(Math.random() * (ttl - min + 1)) + min;
    owl.owlCarousel({
      loop:false,
      margin: 0,
      nav: false,
      lazyLoad: false,
      dots: false,
      items: 1,
      startPosition: randomized

    });
  }

  if($('.collection-slider').length) {
    var owl = $('.collection-slider');
    owl.on('initialized.owl.carousel',function(event) {
      var element = $(event.target);     	
    });
    var mobile_visible = owl.data('items-mobile');
    var desktop_visible = owl.data('items');
    owl.owlCarousel({
      loop:true,
      margin: 10,
      nav: true,
      lazyLoad: true,
      dots: false,
      responsive:{
        0:{
          items: mobile_visible
        },
        600:{
          items: desktop_visible
        }

      },
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }



  //Reusable Functions
  function ProductSlideshow() {
    if($('.product-slideshow').length) {
      var owl = $('.product-slideshow');
      owl.on('initialized.owl.carousel',function(event) {      
        var items     = event.item.count;
        $('.product-slideshow-controls .owl-total').html(items);
        owl.find('.owl-item').fadeIn();
        var element = $(event.target); 



      });

      owl.owlCarousel({
        loop:true,
        margin: 0,
        lazyLoad: true,
        nav: true,
        dots: false,
        items: 1,
        onChanged: onChanged,
        navText: [
          OwlArrowPrev,
          OwlArrowNext
        ]
      });
      $('.owl-next-custom').on('click',function(e) {
        e.preventDefault();
        $('.product-slideshow').trigger('next.owl.carousel');
      });
      $('.owl-prev-custom').on('click',function(e) {
        e.preventDefault();
        $('.product-slideshow').trigger('prev.owl.carousel');
      });
      function onChanged(event) {
        //current will now return current slide #
        var current = (event.item.index + 1) - event.relatedTarget._clones.length / 2;
        var allItems = event.item.count;
        if (current > allItems || current == 0) {
          current = allItems - (current % allItems);
        }
        $('.owl-current').html(current);
      }
    }

    if($('#related-carousel').length) {
      var owl = $('#related-carousel');
      owl.on('initialized.owl.carousel',function(event) {
        var element = $(event.target);     	
        owl.find('.owl-item').fadeIn();
        $('#related-carousel').imagesLoaded(function(){
          //var h = ($('#index-carousel-1').find('.prod-image-wrap').height() / 2) + ($('#index-carousel-1 .owl-prev').height() / 2);
          var h = ($('#related-carousel').find('.owl-item').height() - $('#related-carousel').find('.prod-image-wrap').height()) / 2 + 5 ;
          $('#related-carousel .owl-prev').css("margin-top","-"+h+"px");
          $('#related-carousel .owl-next').css("margin-top","-"+h+"px");
        });
      });
      var mobile_visible = $('#related-carousel').data('items-mobile');
      var desktop_visible = $('#related-carousel').data('items');
      owl.owlCarousel({
        loop:true,
        margin: 10,
        nav: true,
        lazyLoad: true,
        dots: false,
        responsive:{
          0:{
            items: mobile_visible
          },
          600:{
            items: desktop_visible
          }

        },
        navText: [
          OwlArrowPrev,
          OwlArrowNext
        ]
      });
    }
    if($('.mobile-product-images').length) {
      $('.mobile-product-images').owlCarousel({
        loop:true,
        margin: 0,
        nav: true,
        dots: true,
        //lazyLoad: true,
        items: 1,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="16.6" height="34.8" viewBox="0 0 16.6 34.8" xml:space="preserve"><polyline points="16.4 0.3 0.5 17.4 16.4 34.5 " style="fill:none;stroke-width:0.8;stroke:#959494"/></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="16.6" height="34.8" viewBox="0 0 16.6 34.8" xml:space="preserve"><polyline points="0.3 34.5 16.1 17.4 0.3 0.3 " style="fill:none;stroke-width:0.8;stroke:#959494"/></svg>'
        ]
      });
    }
  }
  //Call this one now
  ProductSlideshow();

  function ProductReviews() {
    var urls = ["\/\/productreviews.shopifycdn.com\/assets\/v4\/spr.js?shop=fezshoes.myshopify.com"];
    for (var i = 0; i < urls.length; i++) {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = urls[i];
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
  }

  if($('.owl-modal-carousel').length) {
    var owl = $('.owl-modal-carousel');
    owl.on('initialized.owl.carousel',function(event) {
      // Just in case we need it, this goes first.
      //owl.find('.owl-item').fadeIn();
      var element = $(event.target);     	

    });
    owl.owlCarousel({
      loop:true,
      margin: 0,
      lazyLoad: true,
      nav: true,
      dots: false,
      items: 1,
      navText: [
        OwlArrowPrev,
        OwlArrowNext
      ]
    });
  }


  $('.ww-swatch').on('click',function(e) {
    e.preventDefault();
    if($(this).hasClass('active')) {

    } else {
      var newImg = $(this).data('image');
      var myShoe = $(this).parents('.ww').data('shoe');
      var myURL = $(this).attr('href');
      $('#'+myShoe).attr('href',myURL);
      $(this).parent().parent().find('img').removeClass('lazyautosizes').removeClass('lazyloaded').attr('src',newImg).attr('data-src',newImg).addClass('lazyload');
      $(this).parent().find('.ww-swatch').removeClass('active');
      $(this).addClass('active');
    }
  });

  $('.ww').each(function(i,v) {
    var me = $(this);
    var myShoe = $(this).data('shoe');
    var myURL = me.find('.ww-swatch').eq(0).attr('href');
    $('#'+myShoe).attr('href',myURL);

  });





  $(document).on('click','#mobile-cart, #active-cart',function(e) {
    e.preventDefault();
    $('#mini-cart,#body-cover').toggleClass('is-active');
    $('html').addClass('is--locked');
    $('#body-cover').fadeIn();
    $('#mobile-cart').hide();
    $('#mobile-cart-close').addClass('show').show();
    $('#side-menu').removeClass('open');
    //$('#body-cover').fadeOut();

    $('#nav-toggle').removeClass('open');

    if($(window).width() < 768) {
      $('#mini-cart').css('top',$('#header').outerHeight());
    }
  });



  $(document).on('click','.mini-cart-close, #body-cover,#mobile-cart-close,#mini-cart-bg',function(e) {
    //$('.mini-cart-close, #body-cover,#mobile-cart-close').on('click',function(e) {
    $('#mini-cart,#body-cover').removeClass('is-active');
    $('html').removeClass('is--locked');
    $('#body-cover').fadeOut();
    $('#mobile-cart').show();
    $('#mobile-cart-close').removeClass('show').hide();

  });

  $('.trigger-menu').click(function(e) {
    e.preventDefault();
    $('html').toggleClass('is--locked');
    $('#mini-cart').removeClass('is-active');
    $('#mobile-cart').show();
    $('#mobile-cart-close').hide();

    if($('#side-menu').hasClass('open')) {
      $('#side-menu').removeClass('open');
      $('#body-cover').fadeOut();
      $('#nav-toggle').removeClass('open');

    } else {
      $('#side-menu').addClass('open');
      $('#body-cover').fadeIn();
      $('#nav-toggle').addClass('open');

    }
  });

  $(document).on('click','.remove-item',function(e) {
    $(this).parents('.line-item').fadeOut('fast');
    var id = $(this).data('variant-id');
    Shopify.removeItem(id);
  });

  $(document).on('change','.quantity',function(e) {
    e.preventDefault();
    var me = $(this).data('variant-id');
    var val = parseInt($(this).val());
    $('#cart-wrapper .overlay').fadeIn();
    Shopify.changeItem(me,val);
    CheckCurrency();
  });


  $(document).on('change','.cart-size-change',function(e) {
    e.preventDefault();
    $('#cart-wrapper .overlay').fadeIn();
    var removeID = $(this).data('variant-id');
    var addID = $(this).val();
    var myQty = parseInt($('#qty-'+removeID).val());
    Shopify.removeItem(removeID,function() {
      Shopify.addItem(addID,myQty);

    });
  });



  $('#body-cover,.side-menu-header__close').click(function(e) {
    e.preventDefault();
    $('html').removeClass('is--locked');
    $('#body-cover').fadeOut();
    $('#side-menu').removeClass('open');
  });

  $('.side-has-sub > a').click(function(e) {
    if($(this).parent().parent().hasClass('sub-sub-side-menu') || $(this).parent().hasClass('tolink')) {
    } else {
      e.preventDefault();  	
    }
    $(this).siblings('.sub-side-menu').slideToggle('fast','myEase');
    $(this).parent().toggleClass('open');
  });





  if($(window).width() < 768) {
    $('.footer-header').on('click',function(e) {
      e.preventDefault();
      $(this).next().slideToggle();
    });
  }





  $(document).on('mouseenter','.collection-filter',function(e)  {
    e.preventDefault();
    var mytab = $($(this).attr('href'));
    $('.collection-filter').removeClass('active');
    $('.filter-group').removeClass('active');
    mytab.addClass('active');
    $(this).addClass('active');
  });

  $(document).on('click','.collection-filter', function(e) {
    e.preventDefault();
  });


  $(document).on('mouseleave','.collection-filters',function(e) {
    e.preventDefault();
    var mytab = $($(this).attr('href'));
    $('.collection-filter').removeClass('active');
    $('.filter-group').removeClass('active');
  });

  //Cookies.remove('hide_header_signup');

  $(document).on('click','#hide-header-signup',function(e) {
    e.preventDefault();
    Cookies.set('hide_header_signup', 'true', { expires: 365 });
    $('#header-signup').hide();
    $('#main').removeClass('header-signup-visible');
  });

  if(Cookies.get('hide_header_signup') != 'true' && $(window).width > 768) {
    $('#header-signup').slideDown();
    $('#main').addClass('header-signup-visible');
  } 



  $(document).on('click','.tab-header',function(e) {
    e.preventDefault();
    var mytab = $(this).attr('href');
    $('.tab-header').removeClass('active');
    $('.tab-content').removeClass('active').hide();
    $(this).addClass('active');
    $(mytab).fadeIn().addClass('active');

  });

  $(document).on('mouseenter','.wash-instructions li',function() {
    $('.wash-instructions li').removeClass('current');
    $('.wash-instructions .wash-instruction-text').hide();
    $(this).addClass('current');
    $(this).find('.wash-instruction-text').show();
  });

  $(document).on('mouseleave','.wash-care',function() {
    $('.wash-instructions li').removeClass('current');
    $('.wash-instructions .wash-instruction-text').hide();
    $('.wash-instructions li:nth-child(1)').addClass('current').find('.wash-instruction-text').show();
  });



  function checkFilters() {
    if($('.filter-group .coll-filter:checked').length) {
      var me = $('.filter-group .coll-filter:checked');
      me.each(function(i,v) {
        var myindex = $(this).parents('.filter-group').index();
        $('.collection-filter').eq(myindex-1).addClass('is-filtered');  
      });
    } else {
      var me = $('.filter-group .coll-filter');
      me.each(function(i,v) {
        var myindex = $(this).parents('.filter-group').index();
        $('.collection-filter').eq(myindex-1).removeClass('is-filtered');  
      });

    }


    if($('.collection-filters .coll-filter:checked').length) {
      $('.collection-filters .remove-all').addClass('show');
    } else {

      $('.collection-filters .remove-all').removeClass('show');
    }

    if($('#color-filter .coll-filter:checked').length) {
      var currentColor = $('#color-filter .coll-filter:checked').val();
      $('.collection-swatch[data-color="'+currentColor+'"]').trigger('mouseenter');

      setTimeout(function(){
        //$('.collection-swatch[data-color="'+currentColor+'"]').trigger('mouseenter');
        $('#collection-loading').hide();
        $('#collection-main').fadeIn();
      }, 500);

    }
    MFP();
    Reveal();
  }


  /* Collection Filtering */
  var collFilters = $('.coll-filter');
  var newTags = [];
  var collectionTitle = $('#collection-main').data('collection-title');
  var collectionHandle = $('#collection-main').data('collection-handle');

  checkFilters();

  $(document).on('change', '.coll-filter', function() {

    $(this).parent().siblings().find('.coll-filter:checked').prop('checked',false);

    $('#collection-main-inner').hide();
    $('#collection-loading').fadeIn('fast');

    var newTags = [];
    collFilters.each(function() {
      if($(this).is(':checked')) {
        newTags.push(jQuery(this).val());
      }
    });

    if (newTags.length) {
      var query = newTags.join('+');
      var ajaxhref =  '/collections/'+collectionHandle+'/'+query;
    } else {
      var ajaxhref = '/collections/'+collectionHandle;                 
    }

    $('.collection-grid').html('');

    $.get(ajaxhref+'?view=ajax', function(data) {
      var newCollection = $(data).find('.collection-grid').html();
      $('.collection-grid').append(newCollection);
      //As needed
      checkFilters();
      CheckCurrency();
      $('#collection-loading').fadeOut('slow');
      $('#collection-main-inner').fadeIn();
    });


    //push state stuff (url change)
    var title = document.getElementsByTagName("title")[0].innerHTML;
    window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);

    if($(this).parent().parent().attr('id') == 'size-filter') {
      Cookies.set('size-filter',$(this).val());
    }


    checkFilters();

    if($(window).width() < 768) {
      $('#all-filters .filters').hide();
    }

  });  //end onChange


  $(document).on('click','.remove',function(e) {
    //e.preventDefault();
    //$(this).hide();
    $(this).parent().siblings('.filter-elem').find('input:checkbox').prop('checked', false).first().trigger('change');
  });


  $(document).on('click','.prod-swatches-close',function(e) {
    e.preventDefault();
    $(this).parent().removeClass('show').parent().find('.prod-links').show();
    $(this).parent().parent().find('.prod-swatches').removeClass('show');
  });

  $(document).on('click','.prod-color-link',function(e) {
    e.preventDefault();
    $(this).parent().hide().parent().find('.prod-swatches').addClass('show');
    $(this).parent().parent().find('.prod-quick').removeClass('show');
  });

  $('.prod-quicklook-link').on('click',function(e) {
    e.preventDefault();
  });

  $(document).on('click','.remove-all',function(e) {
    e.preventDefault();
    $(this).removeClass('show');
    $('.filter-group .remove').hide();
    $('.coll-filter').removeAttr('checked');
    //checkFilters();
    $('.collection-filter').removeClass('is-filtered');

    var ajaxhref = $(this).attr('href');
    $.get(ajaxhref, function(data) {
      var newCollection = $(data).find('.collection-grid').html();
      $('.collection-grid').html(newCollection);
      checkFilters();
      CheckCurrency();
      $('#collection-loading').fadeOut('slow');
      $('#collection-main-inner').fadeIn();
    });
  });

  $(document).on('click','.mobile-filter-close', function(e) {
    e.preventDefault();
    $('.filters').fadeOut();
  });
  $(document).on('click','.pagination a', function(e) {
    e.preventDefault();
    var ajaxhref = $(this).attr('href');
    $('#collection-main').load(ajaxhref + ' #collection-main-inner');  
    var title = document.getElementsByTagName("title")[0].innerHTML;
    window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);
    $('html, body').animate({
      scrollTop: $("#collection-main").offset().top - $('#header').outerHeight() - 50
    }, 1000);
  });

  $('.sidebar-accordion a.active').parent().prev().trigger('click');


  if(Cookies.get('products_per_row') != undefined) {
    $('.product').removeClass('three-per-row').removeClass('four-per-row').addClass(Cookies.get('products_per_row'));
    $('.view-num').removeClass('active');
    $('.view-num[data-value="'+Cookies.get('products_per_row')+'"').addClass('active');
  }

  $(document).on('click','.view-num',function(e) {
    e.preventDefault();
    var myVal = $(this).data('value');
    $('.product').removeClass('three-per-row').removeClass('four-per-row').addClass(myVal);
    Cookies.set('products_per_row', myVal);
    $('.view-num').removeClass('active');
    $(this).addClass('active');

  });



  /*$(document).on('click','.other-colors a', function(e) {
    e.preventDefault();
    if(!$(this).parent().hasClass('active')) {
      var ajaxhref = $(this).attr('href');
      var title = document.getElementsByTagName("title")[0].innerHTML;
      window.history.pushState({url: "" + ajaxhref + ""}, title, ajaxhref);

      //var getVa
      $.get(ajaxhref, function(data) {   
        $('#pw').html($(data).find('#pw').html());
        $('#related').html($(data).find('#related').html());
        $('#product-details').html($(data).find('#product-details').html());
        $('#reviews').html($(data).find('#reviews').html());
        $('.breadcrumb').html($(data).find('.breadcrumb').html());
        ProductSlideshow();
        //ProductReviews();
        $('.cloud-zoom').zoom();
        CheckCurrency();
        MFP();
        Reveal();
        if(sizePreference) {
          $('.product-add .btn').prop('disabled',true);
          $('.ph-size input[value="'+sizePreference+'"]').prop('checked',true).trigger('click');


        }       
      });
    }

  });*/




  $(document).on('change','.ph-color input', function() {
    var myColor = $(this).val().toLowerCase();
    $('.product-slideshow').hide();
    $('#slideshow-'+myColor).show();    

    var goto = $('.mobile-product-images [data-color="' + myColor + '"]').parent().index();


    //var owl = 
  });

  $(document).on('change','.ph-size input',function() {
    $(this).parent().parent().find('.current-val').html($(this).val());
    sizePreference = $(this).val();
    Cookies.set('size-preference',$(this).val());

  });

  $(document).on('change','.phs select',function() {
    var myval = this.options[this.selectedIndex].text;
    if (/select/i.test(myval)) myval = '';
    $(this).parent().parent().find('.current-val').html(myval);
  });

  //$('.swatch-element input').trigger('change');

  $('.phs').each(function() {
    var kids = $(this).find('.swatch-element');
    if(kids.length == 1) {
      $(this).find('input[type=radio]').trigger('click');
    }
    if($(this).find('.hidden input:checked').length) {
      console.log('hidden is checked');
    }
  });
  
  if($('.ph-size .hidden input:radio:checked').length) {
    console.log('hidden is checked');
  }
  



  $(document).on('change','.qv .ph-color input',function() {
    var myID = parseInt($(this).parent().index());
    var myProductID = $(this).parents('.qv').attr('id').split('-');
    var parent = $(this).parents('.qv').find('.qv-images');
    if(parent.data('img-'+myID)) {
      parent.find('img').attr('src',parent.data('img-'+myID));
    }
  });


  if(sizePreference) {
    //$('.ph-size input[value="'+sizePreference+'"]').prop('checked',true).trigger('change');
    //$('.product-add .btn').prop('disabled',false);
  } 




  $(document).on('click','.add',function(e) {
    e.preventDefault();

    var btn = $(this);
    var old_btn_txt = btn.val();
    var new_btn_txt = old_btn_txt.replace('Add','Added');
    var time = 3000;
    var form = $(this).parents('form').attr('id');
    var addID = $(this).parents('form').find('.my-hidden-id').val();
    Shopify.addItemFromForm(form);
    //Shopify.addItem(addID,1);



    btn.prop('disabled',true).val(new_btn_txt);

    setTimeout(function() {
      btn.prop('disabled',false).val(old_btn_txt); 
    }, time);
  });


  $(document).on('click', '.spr-badge', function(e) {
    e.preventDefault();

    $('html,body').animate({
      scrollTop: $('#reviews').offset().top
    }, 500);
  });

  $(document).on('click','.size-guide-link', function(e) {
    e.preventDefault();
    $("#size-popup").modal({
      overlayClose:true
    });
  });



  $(document).on('click','#main-image > a', function(e) {
    e.preventDefault();
  });

  $(document).on('click','.zoom', function(e) {
    e.preventDefault();
    $('#image1-link').trigger('click');
  });


  $('.faq-accordion .question').on('click',function(e) {
    e.preventDefault();
    $(this).toggleClass('faq-open').next().slideToggle();
  });

  $('a.rel').on('click',function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr("href")).offset().top - $('#header').height()
    }, 500);
  });

  $('a#scroll-to-top').on('click',function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  });


  $("[data-sticky_column]").stick_in_parent({
    parent: "[data-sticky_parent]"
  });





  $('.mfp-gallery').magnificPopup({
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    removalDelay: 500,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true
    },
    gallery: {
      enabled: true
    }

  });

  $(document).on('click','.quick-view, .quick-view-btn',function(e) {
    e.preventDefault();
    var myHref = $(this).attr('href');
    $.magnificPopup.open({
      items: {
        src: myHref,
        type: 'inline'
      }
    });
  });

  $("#bespoke .jewelry-type").on('change',function() {
    //var value = $(this).val();
    if($(this).val() == 'Rings') {
      $('#ring-size').slideDown();
      $('#chain-size').slideUp();
      $("#chain-size input:radio").attr("checked", false);
    } else if($(this).val() == 'Pendants') {
      $('#ring-size').slideUp();
      $("#ring-size input:radio").attr("checked", false);
      $('#chain-size').slideDown();
    } else {
      $('#ring-size').slideUp();
      $('#chain-size').slideUp();

      $("#ring-size input:radio").attr("checked", false);
      $("#chain-size input:radio").attr("checked", false);
    }
  });


  $(document).on('click','.accordion h3',function(e) {
    $(this).toggleClass('active').next().slideToggle('fast','myEase').toggleClass('active');
  });




  /* Customer page stuff */
  $(document).on('click','.customer-link',function(e) {
    e.preventDefault();
    var myTab = $($(this).attr('href'));
    $('.customer-link').removeClass('active');
    $(this).addClass('active');
    var title = document.getElementsByTagName("title")[0].innerHTML;
    window.history.pushState({url: "" + myTab + ""}, title, $(this).attr('href'));

    $('.account-tab-content').hide().css('opacity','0').css('visibility','hidden');
    myTab.css('visibility','visible').css('opacity','1');
    myTab.fadeIn();
    $('#customer-main').css('opacity','1');
  });



  // Initialize observers on address selectors, defined in shopify_common.js
  /*
  if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }
  */

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $(document).on('click','.address-new-toggle',function(e) {
    e.preventDefault();
    var $newAddressForm = $('#AddressNewForm');
    $('#addresses-main').toggleClass('hidden');

    $newAddressForm.toggleClass('hidden');
  });

  $(document).on('click','.address-edit-toggle',function(e) {
    e.preventDefault();
    var formId = $(this).data('form-id');
    $('#addresses-main').toggleClass('hidden');
    $('#EditAddress_' + formId).toggleClass('hidden');

  });

  $(document).on('click','.address-delete',function(e) {
    e.preventDefault();
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');

    // eslint-disable-next-line no-alert
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });



  $('.qty-minus').on('click',function(e) {
    e.preventDefault(); 
    var val = parseInt($(this).next().val());
    var input = $(this).next();
    var newval = val-1;
    if(input.val() > 1) {
      input.val(newval); 
    }
    if(input.val() <= 0) {
      input.val(1);
    }
    $(this).parents('form').find('.add').attr('data-qty',newval);
  });
  $('.qty-plus').on('click',function(e) {
    e.preventDefault(); 
    var val = parseInt($(this).prev().val());
    var input = $(this).prev();
    var newval = val+1;
    input.val(newval);
    /*
    if(newval<=20) {
      input.val(newval);
    } else {
      input.val(20);
    }
    */
    $(this).parents('form').find('.add').attr('data-qty',newval);

  });

  $('#hide-filters').on('click',function(e) {
    e.preventDefault();
    $( this ).toggleClass("visible").toggleClass("hidden");
    $('#all-filters').slideToggle('fast','myEase');
  });

  if($(window).width() < 768) {
    $('.footer-link.has-submenu').on('click',function(e) {
      e.preventDefault();
      $(this).next().slideToggle('fast','myEase');
    });
    //$(this).toggleClass('active').next().slideToggle('fast','myEase').toggleClass('active');
    $('#hide-filters').toggleClass("visible").toggleClass("hidden");
    //$('#all-filters').hide();
  }


  //Throttled scroll listener
  $(window).scroll( $.throttle( 250, function() {
    var y = $(this).scrollTop();
    if(y > 172) {
      $('#header').addClass('collapse');
    } else {
      $('#header').removeClass('collapse');
    }
    var ajaxhref = false;
    var paged = false;
    if($('.pagination').length) {
      if($('.pagination').visible() && paged == false) {

        var ajaxhref = $('.pagination .next').attr('href');
        $('.pagination').remove();
        //console.log('boo');
        $.get(ajaxhref, function(data) {   
          paged = true;
          var newCollection = $(data).find('.collection-grid').html();
          var newPagination = $(data).find('.pagination').html();
          $('.collection-grid').append(newCollection);
          $('.pagination').html(newPagination);
          CheckCurrency();

          /*
        setTimeout(function(){
          var currentColor = $('#color-filter .coll-filter:checked').val();
          $('.collection-swatch[data-color="'+currentColor+'"]').trigger('mouseenter');
        }, 1000);
        */
          paged = false;
        });

      }
    }

  }) ); // This is the line you want!

  
  /* AJAX Mailchimp */
  ajaxMailChimpForm($("#index-mc"), $("#index-mc-responses"));
  ajaxMailChimpForm($("#mc"), $("#mc-responses"));
  ajaxMailChimpForm($("#mc-popup"), $("#mc-popup-responses"));

  // Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){
    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();
      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
        //$resultElement.css("color", "white");
        $resultElement.fadeIn();
      } else {
        $resultElement.fadeIn();
        //$resultElement.css("color", "white");
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }
  // Validate the email address in the form
  function isValidEmail($form) {
    // If email is empty, show error message.
    // contains just one @
    var email = $form.find("input[type='email']").val();
    if (!email || !email.length) {
      return false;
    } else if (email.indexOf("@") == -1) {
      return false;
    }
    return true;
  }


  //var ajaxChimpURL = '//sloaneandtate.us6.list-manage1.com/subscribe/post-json?u=ab7ecc3ba8d2309fdc1926320&id=f9994b0171&c=?'
  var mcURL = 'https://gbwearcanada.us8.list-manage.com/subscribe/post?u=ef0d254366e7b71aac89fb8f0&amp;id=2a05e94b5e';
  mcURL_array = mcURL.split('post?');

  var ajaxChimpURL = mcURL_array[0]+'post-json?'+mcURL_array[1] + '&c=?';

  function submitSubscribeForm($form, $resultElement) {
    $.ajax({
      type: "GET",
      url: ajaxChimpURL,
      data: $form.serialize(),
      cache: false,
      dataType: "json",
      //jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function(error){
        // According to jquery docs, this is never called for cross-domain JSONP requests

      },
      success: function(data){

        if (data.statusText != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
          $resultElement.css("color", "red");
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
            $resultElement.css("color", "black");
          }
          $resultElement.html(message);
        } else {
          $resultElement.css("color", "black");
          $resultElement.html("Thank you!<br>You must confirm the subscription in your inbox.");
        }
      }
    });
  }
  

  $(document).on('click','#sb-search:not(.search-open) .sb-icon-search',function(e) {  
    e.preventDefault();
    var w = 240;
    $('#sb-search form').width(w);
    $('#sb-search').addClass('search-open');
    setTimeout(function() { $('.sb-search-input').focus() }, 250);
  });

  $(document).on('click','#sb-search.search-open .sb-icon-search',function(e) {
    e.preventDefault();
    if(!$('.sb-search-input').val()) {
      $('.sb-search').removeClass('search-open');
      $('#sb-search form').width(0);
    } else {
      $('#sb-search form').submit();
    }
  });
  
  if($('.swatch.phs').data('total-options') == '1') {
    $('.swatch.phs').eq(0).find('input[type="radio"]').trigger('click').trigger('change');
  }
  
  if($('body').hasClass('template-search')) {
    $('.search-total').text($('#search-totals').data('total-results'));
  }




});

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


$(window).resize(function() {
  //$('#header').data-height
});


$(window).load(function() {
  $('.fieldset.anim input').each(function() {
    if($(this).val() != '') {
      $(this).attr('data-empty', 'false');  
    }
  });
  if($('.fieldset.anim input').data('ui-autocomplete') != undefined) {
    $(e.currentTarget).attr('data-empty', 'false');
  }
  $('input:-webkit-autofill').attr('data-empty','false');

  if(location.hash) {

    //$('a[href="'+window.location.hash+'"').trigger('click');

  }
  $('#customer-main').css('opacity','1');

  
  if($('#product-instagram .fs-has-posts').length) {
    $('#product-instagram').show();
  } else {
    $('#product-instagram').hide();
  }
  
  console.log('boo');
  $('.ph-size .swatch-element:not(.soldout)').eq(0).find('input:radio').trigger('click');
  
  

});
/*
$(window).load(function() {
  //If size is set


  var urlParams = new URLSearchParams(window.location.search);
  if(urlParams.has('variant')) {
    console.log("we've got a variant");
    $('.phs input:checked').trigger('change');
  }
});
*/

$(function() {
//   if($('#school-selector').length) {

//     var spreadsheetID = '1cS8I_wJBrq8YbNDM8PrRUiX_NdMxXhKQelfvgh_NJh8';
//     //Domestic Sheet (1)
//     var worksheet = '1';
//     var url = "//spreadsheets.google.com/feeds/list/" + spreadsheetID + "/"+worksheet+"/public/values?alt=json"; //this is the part that's changed
//     //var url = "//api.airtable.com/v0/appKV6jDOvwwccgRM/USA%20-%20Live?api_key=keyqRlSCyOnF1pVyT";

//     $.getJSON(url, function(data) {
//       var entry = data.feed.entry;

//       var schoolTags = [];


//       $(entry).each(function(){
//         var schoolTag = this.gsx$schooltag.$t ? this.gsx$schooltag.$t : '';
//         $('#school-selector').append('<option value="student-'+schoolTag+'">'+schoolTag+'</option>');
//         schoolTags.push(schoolTag);
//       });
//       console.log(schoolTags);
//     });
//   }
});

var wick = {
  getSchoolList: function () {
    var url = "https://spreadsheets.google.com/feeds/list/1cS8I_wJBrq8YbNDM8PrRUiX_NdMxXhKQelfvgh_NJh8/2/public/values?alt=json",
        $schools = $("[data-school-list]");
    if($schools.length) {
      $schools.empty();
      $.get(url, function (data) {
        var entries = data.feed.entry;
        $.each(entries, function (i, en) {
          var school = en.gsx$schooltag.$t || "";
          var schoolName = school
          .replace("school_", "")
          .split(/(?=[A-Z])/)
          .join(" ");
          $schools.append(
            "<option value='" + school + "'>" + schoolName + "</option>"
          );
        });
        $schools.html(
          $schools.find("option").sort(function (x, y) {
            // to change to descending order switch "<" for ">"
            return $(x).text() > $(y).text() ? 1 : -1;
          })
        );
        $schools.prepend(
          "<option value='' selected='selected'>I do not belong to a school</option>"
        );
		if (typeof $schools.data('my-school') !== 'undefined') {
          console.log($schools.data('my-school'));
          $schools.val($schools.data('my-school'));
        }
      });
    }
  }
};
wick.getSchoolList();




/*
$(window).load(function() {
  // Only run popup on Collection Page
  if(getUrlParameter('cookie') == 'remove') {
     Cookies.remove('popup');
  }
  if($('body').hasClass('template-collection')) {
    if(!$.cookie('popup')) {
      $('#newsletter-triggerly').trigger('click');	
      Cookies.set('popup', 'seenit', { expires: 30 });
    }
  }
});


*/
